import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table } from "@components/Table";
import { ButtonSecondary, ButtonPrimaryLink } from "@components/Button";
import { deletePartnerById } from "@actions/partners.action";
import Modal from "@components/Modal";
import { Span } from "@styles/typography";
import { Row, Indent } from "@styles/grid";

const EditPartner = ({ partnerId }) => {
  const dispatch = useDispatch();
  const loading = useSelector(state => state.partners.loading);

  const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);

  const handleDeletePartner = () => async () => {
    try {
      await dispatch(deletePartnerById(partnerId));
      setIsRemoveModalOpen(false);
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return (
    <Row justify="flex-end" padding="0 2rem 0 0">
      <Indent margin="0 1.5rem 0 0">
        <ButtonPrimaryLink uppercase href={`/partners/${partnerId}`} outlined size="small" weight="bold">
          edit
        </ButtonPrimaryLink>
      </Indent>
      <ButtonSecondary uppercase onClick={() => setIsRemoveModalOpen(true)} size="small" weight="bold">
        Remove
      </ButtonSecondary>

      <Modal isOpen={isRemoveModalOpen} onClose={() => setIsRemoveModalOpen(false)} title="Remove Partner">
        <Indent margin="4rem 0">
          <Span size={1.8}>Are you sure you want to delete this partner?</Span>
        </Indent>
        <Row justify="flex-end">
          <Indent margin="0 2rem 0">
            <ButtonSecondary outlined onClick={() => setIsRemoveModalOpen(false)} uppercase>
              Close
            </ButtonSecondary>
          </Indent>
          <ButtonSecondary autoFocus onClick={handleDeletePartner()} uppercase disabled={loading}>
            Remove
          </ButtonSecondary>
        </Row>
      </Modal>
    </Row>
  );
};

const PartnersTable = () => {
  const { all: partners, fetching } = useSelector(({ partners }) => partners);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        isFiltered: true,
        isSorting: true,
      },
      {
        Header: "Slug",
        accessor: "slug",
        isFiltered: true,
        isSorting: true,
      },
      {
        id: "colEdit",
        Cell: ({ row }) => <EditPartner partnerId={row.original.id} />,
      },
    ],
    []
  );

  const data = useMemo(() => partners, [partners]);

  return <Table columns={columns} data={data} hasGlobalFilter loading={fetching} />;
};

export default PartnersTable;
